import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import deDE from 'antd/locale/de_DE';
import { store } from './store/store';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import DppCreation from './pages/DppCreation/DppCreation';
import BarcodeScanner from './pages/BarcodeScanner/BarcodeScanner';
import DataValidation from './pages/DataValidation/DataValidation';
import DppList from './pages/DppList/DppList';
import DppViewer from './pages/DppViewer/DppViewer';
import Settings from './pages/Settings/Settings';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider locale={deDE}>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Navigate to="/" replace />} />
              <Route path="/dpp-creation" element={<DppCreation />} />
              <Route path="/barcode-scanner" element={<BarcodeScanner />} />
              <Route path="/data-validation" element={<DataValidation />} />
              <Route path="/dpp-list" element={<DppList />} />
              <Route path="/viewer/:dppId" element={<DppViewer />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </Router>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
